import React from 'react'

import { FilterHandler } from '@btime/react-contexts'
import { useUrlFilters } from './_helpers/loadFiltersFromUrl'

const FilterWrapper = ({ children }) => {
  const initialFilter = useUrlFilters()
  return (
    <FilterHandler tempStorageNamespace="logs" initialState={initialFilter}>
      {children}
    </FilterHandler>
  )
}

export default FilterWrapper
